import { useEffect, useState } from 'react';
import './FAQ.css';

// FAQ: Kategorien als Chips, Fragen als aufklappbare Einträge.
// Inhalte spiegeln den aktuellen Stand der App (Live-Zwischenstände,
// Tipps der anderen nach Kickoff, App-Installation).

const KATEGORIEN = [
  {
    key: 'app',
    titel: '📱 Als App nutzen',
    fragen: [
      {
        q: 'Wie bekomme ich Kessel MVP wie eine App aufs Handy?',
        a: 'Du musst nichts aus einem Store laden. Die Seite lässt sich als App auf dem Startbildschirm ablegen und öffnet dann ohne Browser-Leiste im Vollbild.\n\n📱 iPhone / iPad (Safari):\n1. kessel-mvp.de in Safari öffnen (nicht in Chrome!)\n2. Unten das Teilen-Symbol tippen (Quadrat mit Pfeil nach oben)\n3. „Zum Home-Bildschirm“ wählen\n4. Oben rechts „Hinzufügen“\n\n🤖 Android (Chrome):\n1. kessel-mvp.de in Chrome öffnen\n2. Oben rechts das Menü (⋮) tippen\n3. „App installieren“ bzw. „Zum Startbildschirm hinzufügen“\n4. Bestätigen\n\n💻 PC / Mac (Chrome oder Edge):\nIn der Adressleiste erscheint rechts ein kleines Installieren-Symbol (Monitor mit Pfeil). Anklicken, bestätigen – fertig.'
      },
      {
        q: 'Was bringt mir die App-Variante?',
        a: '• Eigenes Icon auf dem Startbildschirm, ein Tipp und du bist drin\n• Vollbild ohne Browser-Leiste, mehr Platz für die Spiele\n• Du bleibst angemeldet\n• Push-Benachrichtigungen funktionieren zuverlässiger (auf dem iPhone sogar nur so)\n\nInhaltlich ist es dieselbe Seite, Updates kommen automatisch.'
      },
      {
        q: 'Ich bekomme keine Push-Benachrichtigungen. Woran liegt das?',
        a: 'Prüfe der Reihe nach:\n\n1. Unter Einstellungen den Schalter „Push-Benachrichtigungen“ auf AKTIV stellen\n2. Im Browser bzw. am Handy die Erlaubnis für Benachrichtigungen erteilen\n3. iPhone: Push geht nur, wenn die Seite als App auf dem Home-Bildschirm liegt (siehe oben) und du sie von dort geöffnet hast\n4. Stromsparmodus oder „Nicht stören“ können Nachrichten verzögern\n\nDu wirst 24 und 6 Stunden vor dem nächsten Kickoff erinnert, aber nur, wenn du für die anstehenden Spiele noch keinen Tipp hast.'
      }
    ]
  },
  {
    key: 'spielregeln',
    titel: '🏈 Spielregeln',
    fragen: [
      {
        q: 'Wie funktioniert das Tippspiel?',
        a: 'Du tippst das Ergebnis jedes NFL-Spiels. Je näher du am Endstand liegst, desto mehr Punkte. Die genauen Werte legt der Admin pro Saison fest und stehen im Punktesystem.'
      },
      {
        q: 'Bis wann kann ich tippen?',
        a: 'Bis zum Kickoff des jeweiligen Spiels. Danach ist das Spiel gesperrt. Jedes Spiel hat seine eigene Frist, du kannst also Sonntagsspiele auch noch tippen, wenn das Donnerstagsspiel schon läuft.\n\nAktiviere Push-Benachrichtigungen, dann wirst du 24 und 6 Stunden vor dem Kickoff erinnert, falls du noch nicht getippt hast.'
      },
      {
        q: 'Kann ich meine Tipps ändern?',
        a: 'Ja, bis zum Kickoff beliebig oft. Geänderte Felder sind orange markiert, bis du unten auf „Tipps speichern“ drückst.'
      },
      {
        q: 'Was passiert, wenn ich ein Spiel nicht tippe?',
        a: 'Dann gibt es für dieses Spiel 0 Punkte. Minuspunkte gibt es nicht.'
      },
      {
        q: 'Kann ich die Tipps der anderen sehen?',
        a: 'Ja, sobald ein Spiel begonnen hat. Auf der Tippseite gibt es dann den Chip „Tipps der anderen“. Während das Spiel läuft, färben sich die Tipps nach dem Zwischenstand, nach dem Endstand endgültig. Für noch nicht gestartete Spiele bleiben alle Tipps geheim.'
      },
      {
        q: 'Was bedeuten „Schnell ausfüllen“ und die Zahlen 24:21?',
        a: 'Damit füllst du alle offenen Spiele einer Woche mit einem Standardtipp: „Favoriten gewinnen“ setzt 24:21 für das laut Buchmacher-Spread favorisierte Team, „Heimteams gewinnen“ 24:20 für alle Heimteams. Danach kannst du einzelne Spiele anpassen. Gespeichert wird erst, wenn du auf „Tipps speichern“ drückst.'
      }
    ]
  },
  {
    key: 'punktesystem',
    titel: '🎯 Punktesystem',
    fragen: [
      {
        q: 'Wie werden Punkte berechnet?',
        a: 'Vier Kategorien:\n\n• EXAKT: beide Scores stimmen genau\n• TENDENZ: Sieger und Punktedifferenz stimmen\n• SIEGER: nur der Sieger stimmt\n• DANEBEN: falscher Sieger\n\nDie Punkte pro Kategorie legt der Admin pro Saison fest. Dazu kann es Boni geben: Heim-/Auswärtssieg-Bonus, „Perfekte Woche“ und Playoff-Multiplikatoren.'
      },
      {
        q: 'Was ist eine „Perfekte Woche“?',
        a: 'Alle Spiele einer Woche mindestens mit dem richtigen Sieger getippt. Ob es dafür einen Bonus gibt und wie hoch er ist, steht im Punktesystem der Saison.'
      },
      {
        q: 'Zählen Playoffs mehr?',
        a: 'Meistens ja. Für Wild Card, Divisional, Conference Championship und Super Bowl kann der Admin Multiplikatoren festlegen, die alle Punkte des Spiels vervielfachen.'
      },
      {
        q: 'Wann werden Punkte aktualisiert?',
        a: 'Während der Spiele siehst du den Zwischenstand live auf der Tippseite, inklusive einer vorläufigen Bewertung deines Tipps. Sobald ein Spiel beendet ist, berechnet der Server die Punkte innerhalb von ein bis zwei Minuten. Das Ranking zeigt sie beim nächsten Öffnen.'
      },
      {
        q: 'Wie funktioniert die Streak?',
        a: 'Eine Streak zählt, wie viele Spiele du in Folge mindestens mit dem richtigen Sieger getippt hast. Ein falscher Tipp setzt sie auf null. Es gibt die Saison-Streak (für Saison-Badges) und die Lifetime-Streak über alle Saisons (für Achievements).'
      }
    ]
  },
  {
    key: 'bonusfragen',
    titel: '🎁 Bonusfragen',
    fragen: [
      {
        q: 'Was sind Bonusfragen?',
        a: 'Vorhersagen für die ganze Saison, zum Beispiel Division-Sieger, #1 Seeds, Wild Cards, Super-Bowl-Champion und MVP. Für jede richtige Antwort gibt es Extra-Punkte. Welche Fragen gestellt werden und was sie wert sind, legt der Admin pro Saison fest.'
      },
      {
        q: 'Wann muss ich die Bonusfragen beantworten?',
        a: 'Zwei Blöcke, zwei Deadlines:\n\n📅 PRE-SEASON: bis zum ersten Spiel der Saison\n🏆 PLAYOFFS: bis zum ersten Playoff-Spiel\n\nDie genaue Frist steht über jedem Block. Der Admin kann sie in Ausnahmefällen verlängern.'
      },
      {
        q: 'Kann ich die Antworten ändern?',
        a: 'Bis zur Deadline ja, beliebig oft. Danach sind sie gesperrt. Nach der Deadline kannst du sehen, was die anderen getippt haben.'
      },
      {
        q: 'Wann gibt es die Punkte dafür?',
        a: 'Am Saisonende. Der Admin bestätigt die richtigen Antworten und lässt die Auswertung laufen. Danach siehst du unter „Bonus“ bei jeder Frage, wie viele Treffer du hattest.'
      }
    ]
  },
  {
    key: 'achievements',
    titel: '🏅 Achievements',
    fragen: [
      {
        q: 'Was sind Achievements?',
        a: 'Auszeichnungen für besondere Leistungen, zu finden in der Hall of Fame.\n\n🏅 LIFETIME-BADGES: über alle Saisons hinweg, zum Beispiel für die Anzahl getippter Spiele oder exakter Tipps, in sieben Stufen von Rookie bis GOAT\n🎯 SAISON-BADGES: pro Saison neu, zum Beispiel Perfekte Woche oder Hot Streak\n\nJedes Badge bringt Achievement-Punkte für ein eigenes Ranking, unabhängig von den Tipp-Punkten.'
      },
      {
        q: 'Wann werden Achievements aktualisiert?',
        a: 'Der Admin stößt die Berechnung manuell an, typischerweise nach einer Woche mit vielen Spielen oder am Saisonende. Wenn dir ein Badge fehlt, das du erreicht haben solltest: kurz warten oder im Board Bescheid sagen.'
      },
      {
        q: 'Was ist das Community-Mitglied-Badge?',
        a: 'Das einzige Badge, das nicht vom Tippen abhängt: Account erstellt, Push aktiviert, Lieblingsteam gewählt, Board-Eintrag geschrieben und so weiter. Die Stufen bauen aufeinander auf, du brauchst also erst Stufe 1, dann 2, dann 3.'
      }
    ]
  },
  {
    key: 'sonstiges',
    titel: '❓ Sonstiges',
    fragen: [
      {
        q: 'Was bringt mir ein Lieblingsteam?',
        a: 'Wähle es unter Einstellungen. Dann werden die Spiele deines Teams auf der Tippseite hervorgehoben, ein Banner zeigt das nächste Spiel, im Ranking bekommst du einen eigenen Reiter mit Statistiken zu deinem Team, und du schaltest eine Stufe des Community-Badges frei.'
      },
      {
        q: 'Was passiert am Saisonende?',
        a: 'Nach dem Super Bowl wertet der Admin die Bonusfragen aus und trägt die Saison in die Hall of Fame ein: Podest, alle Platzierungen, Medaillenspiegel. Danach wird die neue Saison angelegt. Deine Lifetime-Achievements bleiben erhalten.'
      },
      {
        q: 'Gibt es Preise?',
        a: 'Das entscheidet ihr untereinander. Die App liefert die Punkte, die Regeln für Pott, Bierstrafen oder Ruhm und Ehre macht die Runde selbst.'
      },
      {
        q: 'Wo kann ich Feedback geben oder Fehler melden?',
        a: 'Im Board. Die Admins lesen mit. Wenn etwas nicht funktioniert, hilft ein kurzer Hinweis, wo genau und auf welchem Gerät.'
      }
    ]
  }
];

function FAQ() {
  const [kategorie, setKategorie] = useState('app');
  const [offen, setOffen] = useState(null);
  const [installPrompt, setInstallPrompt] = useState(null);
  const [installiert, setInstalliert] = useState(false);

  // Android/Desktop-Browser bieten die Installation per Event an
  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setInstallPrompt(e); };
    const onInstalled = () => { setInstalliert(true); setInstallPrompt(null); };
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const laeuftAlsApp = window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;

  const handleInstall = async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    const { outcome } = await installPrompt.userChoice;
    if (outcome === 'accepted') setInstalliert(true);
    setInstallPrompt(null);
  };

  const aktiv = KATEGORIEN.find(k => k.key === kategorie) || KATEGORIEN[0];

  return (
    <div className="seite faq-seite">
      <h1>❓ FAQ</h1>
      <p className="seite__untertitel">Alles, was du über Kessel MVP wissen musst.</p>

      {kategorie === 'app' && (
        <div className={`faq-install${laeuftAlsApp || installiert ? ' faq-install--fertig' : ''}`}>
          {laeuftAlsApp || installiert ? (
            <span>✅ Du nutzt Kessel MVP bereits als App.</span>
          ) : installPrompt ? (
            <>
              <span>Dein Browser kann Kessel MVP direkt installieren.</span>
              <button type="button" className="faq-install__button" onClick={handleInstall}>📲 Jetzt installieren</button>
            </>
          ) : (
            <span>Anleitung für dein Gerät steht in der ersten Frage unten.</span>
          )}
        </div>
      )}

      <div className="chips" role="tablist">
        {KATEGORIEN.map(k => (
          <button key={k.key} type="button" className={`chip${kategorie === k.key ? ' ist-aktiv' : ''}`} onClick={() => { setKategorie(k.key); setOffen(null); }}>
            {k.titel}
          </button>
        ))}
      </div>

      <div className="karte faq-liste">
        <h2>{aktiv.titel}</h2>
        {aktiv.fragen.map((f, i) => {
          const istOffen = offen === i;
          return (
            <div key={i} className={`faq-eintrag${istOffen ? ' ist-offen' : ''}`}>
              <button type="button" className="faq-eintrag__frage" onClick={() => setOffen(istOffen ? null : i)} aria-expanded={istOffen}>
                <span>{f.q}</span>
                <span className="faq-eintrag__pfeil">{istOffen ? '−' : '+'}</span>
              </button>
              {istOffen && <div className="faq-eintrag__antwort">{f.a}</div>}
            </div>
          );
        })}
      </div>

      <p className="faq-fuss">💡 Noch Fragen? Schreib sie ins Board, die Runde hilft gern.</p>
    </div>
  );
}

export default FAQ;
